import { JsonLd } from "@/components/seo/JsonLd";
import { organizationSchema, webSiteSchema } from "@/components/seo/schemas";
import { useSchemaIndexable } from "@/components/seo/useSchemaIndexable";

interface GlobalSchemaProps {
  pageType: string;
  entityId?: string;
}

/**
 * Injects Organization + WebSite JSON-LD on indexable pages.
 * Place once per page layout.
 */
export function GlobalSchema({ pageType, entityId }: GlobalSchemaProps) {
  const indexable = useSchemaIndexable(pageType, entityId);
  if (!indexable) return null;

  return <JsonLd data={[organizationSchema(), webSiteSchema()]} />;
}
